import { Component } from '@angular/core';
import { textoTerms } from '../../shared/textos';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {

  condicionesFull = `

  <h3>Términos y Condiciones<h3>

  <p>

  TIP de México, S.A.P.I. de C.V., TIP Auto, S.A. de C.V. sus empresas filiales, subsidiarias y/o partes relacionadas, Engencap Holding, S. de R.L. de C.V.,
  Engencap Fin, S.A. de C.V., SOFOM, ENR, Engencap, S. de R.L. de C.V. (conjuntamente, denominados como <strong> “TIP” </strong>) exhortan al Cliente (término definido más adelante)
  a leer de forma exhaustiva los presentes términos y condiciones <strong> (“Términos y Condiciones”). </strong>

  </p>

  <p>

  <strong> Aceptación de Términos y Condiciones. </strong>

  </p>

  <p>

  Al ingresar, visualizar, observar y utilizar esta Página Web, incluyendo cualquiera de las subpáginas que desplieguen su contenido o cualquiera de sus enlaces y/o al
  acceder al Contenido (término definido más adelante), el Cliente está consintiendo i) la generación de una relación jurídica con TIP,
  así como una posible relación comercial y ii) el contenido de los Términos y Condiciones. De igual forma, manifiesta expresamente la aceptación y consentimiento de los
  Términos y Condiciones a través de medios electrónicos de conformidad con la normatividad aplicable, por lo que queda sujeto irrevocablemente a los mismos.

  </p>

  <p>

  Para efectos de los Términos y Condiciones, se entenderá como Cliente a cualquier persona física o moral, de cualquier naturaleza, que use,
  acceda, descargue y/o ingrese a la Página Web y/o a cualquiera de las subpáginas y/o enlaces que desplieguen su contenido <strong> (“Cliente”). </strong>

  </p>

  <p>
  En caso de no aceptar en forma absoluta y completa los Términos y Condiciones, el Cliente deberá abstenerse de acceder, utilizar, observar y/o visualizar la Página Web y su Contenido.
  </p>

  <p>
  Cualquier modificación a los Términos y Condiciones será realizada cuando TIP lo considere apropiado, siendo responsabilidad del Cliente consultar el texto vigente mediante la consulta de la Página Web.
  </p>

  <p>

  El Cliente otorga su consentimiento para que los datos personales que comparta a través de la Página Web sean tratados de conformidad con nuestro Aviso de Privacidad
  contenido en <a href="https://www.tipmexico.com/avisoprivacidad.html" target="_blank" > Aviso de privacidad </a>.

  </p>

  <p>

  Asimismo, el Cliente está de acuerdo que la información requerida por TIP podrá solicitarse a través de diversos formularios, los cuales podrán contener términos y condiciones adicionales, mismos que se entenderán incorporados a estos Términos y Condiciones, aun y cuando esto no se señale expresamente en ellos.

  </p>


  <p>
  Aunado a lo anterior, el Cliente declara bajo protesta de decir verdad que toda la información proporcionada a TIP es verídica y no contiene errores, ni algún tipo de vicio que pueda inducir a TIP al error o a una incorrecta interpretación que favorezca la contratación de los productos de TIP. Asimismo, el Cliente sabe y está de acuerdo que la información proporcionada es y será requisito indispensable para la posible contratación de los productos de TIP, por lo que en caso de que se detecte alguna irregularidad o falsedad en la misma, se suspenderá o cancelará de forma inmediata el análisis de la misma y, en caso de haberse formalizado la contratación de algún producto o haberse celebrado una relación contractual y/o comercial con TIP, TIP podrá terminar o rescindir cualquier relación bajo los términos señalados en el instrumento correspondiente o en los términos que resulten aplicables. En su caso, TIP podrá dar aviso a las autoridades correspondientes de dichas irregularidades sin responsabilidad alguna para TIP.
  </p>



  <p>   <strong>  Alcances. </strong> </p>

  <p>
    TIP solicitará al Cliente, su nombre o razón social, Registro Federal de Contribuyentes, giro, industria, fecha de constitución,
    fecha de inicio de actividades, ingresos del último ejercicio fiscal y posteriormente su NIP
    (término definido más adelante), con la finalidad de consultar periódicamente su historial crediticio y llevar a cabo el
    análisis crediticio para la posible contratación de los productos de TIP.
  </p>

  <p>

  La revisión y el análisis de la información del Cliente consistirán en revisiones periódicas de su historial crediticio y consultas en bases de datos o listas de
  verificación de información de diversa naturaleza legal ligadas a la relación jurídica y comercial que guarda con TIP con un enfoque de
  prevención de riesgos y cumplimiento regulatorio. Asimismo, la autorización que el Cliente otorga a TIP para consultar su historial crediticio
  mediante la Página Web de conformidad con los Términos y Condiciones, permanecerá vigente por un periodo de (3) tres años contados a partir de la
  fecha de inicio de las consultas mencionadas y, en todo caso, durante el tiempo que se mantenga la relación jurídica con TIP.

  </p>

  <p>

  Aunado a lo anterior, en caso de que derivado del análisis realizado por TIP se formalice la contratación de algún producto con TIP, el
  Cliente deberá proporcionar toda la información adicional que TIP requiera para la formalización de dicha contratación.
  Toda la información que el Cliente proporcione a TIP, tanto para la generación de su NIP como para la contratación de los productos y
  servicios ofertados por TIP, se regirán bajo i) los Términos y Condiciones, ii) las obligaciones contenidas en el contrato correspondiente y iii)
  el aviso de privacidad señalado previamente.

  </p>

  <p>

  El Cliente sabe y está de acuerdo en que el envío de información no garantiza de manera alguna la contratación de los servicios de TIP, por lo que
  de ninguna manera podrá considerarse que TIP tiene obligación de proporcionar producto o servicio alguno, reservándose en todo momento la aceptación de la
  contratación de cualquier servicio u otorgamiento de cualquier producto.

  </p>

  <p> <strong>  NIP. </strong> </p>

  <p>

  A través de la Página Web, el Cliente generará su número de identificación personal <strong> (“NIP”) </strong> introduciendo la información que se solicita en el apartado correspondiente,
  el cual fungirá como su autorización inequívoca para que TIP pueda realizar las consultas e investigaciones, sobre su comportamiento crediticio así como en las
  bases de datos y listas de verificación previamente mencionadas. El NIP es confidencial y únicamente el Cliente tendrá acceso a éste para los fines establecidos
  en los presentes Términos y Condiciones. Por lo tanto, el Cliente declara que la información que proporciona para la generación del NIP es verídica,
  así como que tiene pleno conocimiento de la naturaleza y alcance del uso de la información que se le dará a esta. En caso de que el Cliente
  llegará a extraviar su NIP, deberá realizar el procedimiento de generación de NIP nuevamente debido a que es confidencial y únicamente el Cliente tiene acceso a este.

  </p>

  <p> <strong>   Uso y Autorización de medios electrónicos. </strong> </p>

  <p>

  El Cliente al aceptar los Términos y Condiciones, otorga su consentimiento expreso e irrevocable, para que a partir de la fecha de aceptación del presente,
  todos y cada uno de los actos jurídicos que se deban o requieran formalizar entre el Cliente y TIP, relacionados con la presente Página Web, puedan ser suscritos y/o
  celebrados, enunciativamente y no limitativamente, a través de páginas web, aplicaciones móviles, equipos, sistemas automatizados de procesamiento de datos y/o
  cualquier tecnología de información y comunicación (“Medios Electrónicos”) y se puedan celebrar y/o suscribir autorizaciones de forma remota y/o a distancia,
  a través de Internet, cualquier plataforma, sistema electrónico y/o nueva tecnología que TIP ponga a disposición del Cliente para la firma y/o
  suscripción de la información generada, enviada, recibida o archivada por medios electrónicos de conformidad con cualquier disposición aplicable en México respecto a la materia.

  </p>

  <p>

  En consecuencia, el Cliente está de acuerdo que, salvo pacto en contrario por escrito, cualquier autorización y /o manifestación de su consentimiento a
  través de los Medios Electrónicos que TIP determine para tal efecto serán, al igual que la firma autógrafa,
  un medio para manifestar su consentimiento, y cuando los mismos sean firmados de forma electrónica, sustituirán a la firma autógrafa, produciendo los mismos
  efectos que otorga esta última, incluyendo el valor probatorio en juicio.

  </p>

  <p>

  El uso de los Medios Electrónicos que TIP determine para tal efecto, se regirá sin excepción alguna, por los Términos y Condiciones; no obstante lo anterior,
  el Cliente sabe y está de acuerdo que cuando TIP requiera su firma autógrafa de cualquier documento, dicha firma sustituirá a los Medios Electrónicos,
  por lo que todos y cada uno de los documentos firmados de manera autógrafa tendrán la misma fuerza, validez y efectos legales que la legislación aplicable le otorgue.

  </p>

  <p>
  El Cliente sabe y está de acuerdo que la custodia, control y cuidado del NIP generado para la aceptación de las consultas antes referidas son enteramente su responsabilidad y en este acto reconoce y está de acuerdo que el carácter de dichas contraseñas es personal, intransferible y confidencial, por lo que deslinda de cualquier tipo de responsabilidad a TIP por el mal uso que pudiera hacer de las mismas, así como cualquier mal uso de los Medios Electrónicos que TIP haya determinado para tal efecto, por lo que será responsabilidad exclusiva del Cliente cualquier quebranto, daño y/o perjuicio que pudiera sufrir TIP como consecuencia del uso indebido del NIP.
  </p>

  <p>
  El Cliente está de acuerdo que en caso de que llegase a proporcionar información falsa y/o inexacta se considerará como incumplimiento frente a TIP y podrá ser causa de interrupción y cancelación inmediata de los documentos relacionados y/o documentos futuros o de cualquier relación futura establecida entre el Cliente y TIP, sin responsabilidad alguna para TIP.
  </p>

  <p>
  Asimismo, el Cliente sabe y está de acuerdo que en ningún caso y por ningún motivo TIP será responsable de algún daño, incluyendo, de manera enunciativa mas no
  limitativa, daños, pérdidas, gastos directos, indirectos, inherentes o consecuentes que surjan en relación con el uso de la Pagina Web, su uso o
  imposibilidad de uso, o en relación con cualquier falla en el rendimiento, error, omisión, interrupción, defecto, demora en la operación o
  transmisión de virus de computadora o falla de sistema o línea que no sean directamente imputables a TIP. Al usar, acceder, descargar, instalar,
  obtener o brindar información desde y hacia esta Página Web, se considerará que los Clientes han leído y aceptado estos Términos y Condiciones.
  El Cliente sabe y entiende que todas las referencias a la "Página Web" en la Política de Privacidad también se consideran válidas para esta Página Web, ya sea que se
  utilice en forma conjunta o independientemente del Sitio Web de  <a href="https://www.tipmexico.com/" target="_blank" > TIP </a>.
  </p>

  <p>   TIP se reserva el derecho de eliminar o prohibir a cualquier Cliente la utilización de esta Página Web.   </p>

  <p> <strong> Responsabilidad del Cliente. </strong> </p>

  <p>
  En caso de que el Cliente sea una persona moral, declara bajo protesta de decir verdad ser representante legal de la persona moral y por lo tanto cuenta
  con la autorización y los poderes necesarios para obligar a su representada bajo los presentes Términos y Condiciones; manifestando que a la fecha de firma de
  la presente autorización sus facultades no le han sido revocadas, limitadas, ni modificadas en forma alguna. De igual forma, el Cliente manifiesta que con
  fundamento en lo señalado en el artículo 10 de la Ley General de Sociedades Mercantiles, así como el artículo 2551 del Código Civil Federal, no existe impedimento
  legal alguno para autorizar a TIP, para que por conducto de sus funcionarios facultados, realice consultas e investigaciones de mi historial crediticio o de la
  persona moral que represento en Trans Union de México, S. A. SIC y/o Dun & Bradstreet, S.A. SIC; asimismo, declaro que conozco la naturaleza y alcance de la
  información que se solicitará y del uso que TIP hará de tal información. De igual forma, el Cliente reconoce y está de acuerdo que la presentación de
  documentación o información falsa o alterada, o la simulación del cumplimiento de estos requisitos, así como la representación sin autorización, pueden ser
  consideradas como delitos y podrán ser sancionadas conforme al artículo 11 del Código Penal Federal y la legislación aplicable.
  </p>


  <p>

  Por lo tanto se presumirá que el NIP ha sido generado y será utilizado por alguien facultado para hacerlo, hasta en tanto el Cliente haya informado a TIP que el NIP no fue autorizado por éste. Por lo anterior, salvo prueba en contrario se presumirá que quien autorizó, generó y utilizó el NIP actuó con la debida diligencia en tanto se cumplan los requisitos de verificación señalados en la Página Web.

  </p>

  <p>
  Además el Cliente se obliga a sacar en paz y a salvo e indemnizar a TIP (incluyendo pero no limitado a sus funcionarios, directivos, consejeros, accionistas o empleados) de cualquier, responsabilidad, cargo, sanción, reclamación o proceso judicial, administrativo o de cualquier otra índole relacionada o derivada, directa o indirectamente, del incumplimiento a lo dispuesto en los Términos y Condiciones, que se inicie en contra de TIP (incluyendo pero no limitado a sus funcionarios, directivos, consejeros, accionistas o empleados) o en contra de cualquier tercero, debiendo el Cliente cubrir a TIP los honorarios legales y gastos en que incurra por la atención de cualesquiera de dichos asuntos.
  </p>

  <p> <strong>   Contenido. </strong> </p>

  <p>
  Se deberá entender por <strong> “Contenido” </strong>  todo el texto, información, datos, fotografías, gráficos, código html, software informático, código fuente, muestras de audio y
  video, marcas y logotipos y similares que aparezcan en este sitio web <strong> ("Página Web") </strong>, pertenecientes a TIP de México, S.A.P.I. de C.V. y TIP Auto, S.A. de C.V.,
  salvo que quede algo contrario expresamente especificado en esta Página Web. Todas las marcas registradas utilizadas en esta Página Web son propiedad de TIP, o en su caso,
  utilizadas con la autorización de sus respectivos titulares. Ningún tercero puede utilizar ni reproducir ninguna marca registrada que incluya, entre otros, logotipos y
  dominios de Internet que utilicen las marcas registradas de TIP (ya sea que se usen o no con letras mayúsculas o espacios) sin el previo consentimiento por escrito de TIP
   o del propietario de la marca registrada. Un Cliente no puede: (a) separar ningún Contenido individual o componente de la Página Web para otro uso que el indicado en relación
   a la misma; (b) incorporar una porción del mismo a los propios programas del Cliente o recopilar cualquier porción en combinación con los propios programas del Cliente; (c)
   transferirlo para ser utilizado por otro servicio; (d) vender, arrendar, ceder, prestar, distribuir, comunicar públicamente, transformar o sublicenciar la Página Web o
   conceder en modo alguno cualquier derecho a la Página Web, absoluta o parcialmente. TIP será responsable de todo mantenimiento o soporte técnico de la Página Web.
   TIP se reserva el derecho de enmendar, complementar o suspender total o parcialmente la Página Web. Asimismo, TIP se reserva el derecho de cambiar los Términos y
   Condiciones en cualquier momento, con vigencia inmediata a partir del momento que se actualiza la Página Web.
  </p>

  <p> <strong>   Actualizaciones de la Página Web. </strong> </p>

  <p>
  TIP puede solicitar a los Clientes que actualicen su versión de su Navegador Web en cualquier momento. Aunque se harán todos los esfuerzos por conservar las configuraciones
  y preferencias personales de los Clientes, seguirá existiendo la posibilidad de que las mismas se pierdan.
  </p>

  <p> <strong> Derechos de autor y marcas registradas. </strong> </p>

  <p> Todo el contenido publicado en esta Página Web es propiedad de TIP y todos los derechos de autor y marcas registradas se encuentran reservados. </p>

  <p> <strong> Responsabilidad limitada de TIP. </strong> </p>

  <p>

  El Cliente reconoce que TIP junto con sus respectivos directivos, personal, empleados y representantes (en conjunto, las  <strong> “Partes Exentas” </strong> ) no serán
  responsables por los daños sufridos, entre otros, daños directos, indirectos, accidentales, incidentales, derivados, circunstanciales, extraordinarios,
  especiales o punitivos de cualquier naturaleza con respecto a esta Página Web por lo que renuncia a todo reclamo, demanda, imputación de responsabilidades,
  causa legal, querella, reclamación de daños y perjuicios, en contra de ellos. El Cliente reconoce que ante cualquier daño antes referido, deberá poner
  fin al uso de esta Página Web. Los Clientes liberarán de toda responsabilidad y exonerarán a TIP, así como a sus accionistas, consejeros, funcionarios,
  representantes de todo reclamo, demanda, responsabilidad civil, causa legal, querella o daños y perjuicios (incluidos los honorarios y los
    gastos razonables de abogados) que surjan como consecuencia del uso que dichos Clientes hagan de la Página Web, incluyendo sin limitar,
    la información que proporcione el Cliente, así como el contenido o entrega incorrecta de la posible información generada en la Página Web. TIP se reserva el derecho,
    por cuenta propia, de asumir la defensa y el control exclusivos de cualquier asunto sujeto a exoneración por parte de los Clientes, pero el hacerlo no
    exime a los Clientes de sus obligaciones de exoneración.

  </p>

    <p> <strong>   Privacidad. </strong> </p>

  <p>

  Cualquier información obtenida por TIP a través de esta Página Web se sujetará a nuestro aviso de privacidad,
  el cual se puede consultar en la siguiente dirección: <a href="https://www.tipmexico.com/avisoprivacidad.html" target="_blank"> https://www.tipmexico.com/avisoprivacidad.html </a>.

  </p>

  <p>

  El uso de esta Página Web implica la transmisión electrónica de información a través de las redes del proveedor de servicio. En vista de que TIP no opera ni controla
  las redes utilizadas para acceder a la Página Web, TIP no es responsable de la privacidad o seguridad de las transmisiones de datos. No obstante,
  los datos personales en posesión de TIP, serán tratados conforme a los principios y deberes establecidos en la Ley Federal de Protección de Datos Personales en
  Posesión de Particulares y normatividad aplicable.

  </p>

  <p>
  Los Clientes deberán utilizar proveedores de servicios acreditados y verificar junto a su proveedor de servicios, la información relativa a sus prácticas en materia de privacidad y seguridad.
  </p>

  <p> <strong>   Patrocinio. </strong> </p>

  <p>
  TIP no recomienda, patrocina ni promociona negocios, servicios o productos de terceros, por lo tanto TIP no es responsable por el uso de
  otros sitios web a los que pudiera acceder el Cliente mientras se encuentra navegando en la Página Web, por lo tanto TIP no será
  responsable ni estará sujeta a acción legal por los servicios o productos de terceros.
  </p>

  <p> <strong>  Exclusión de garantía. </strong> </p>

  <p>
    TIP y las Partes Exentas no hacen manifestación alguna en cuanto a la funcionalidad y uso del contenido de esta Página Web. El uso y
    navegación que haga el Cliente con esta Página Web es a riesgo exclusivo del propio Cliente. Toda la información contenida en esta Página Web es proporcionada
    "tal como está” y “según está disponible”, sin aseveraciones ni garantías, ya sean expresas o tácitas. Los Clientes no deben asumir que la
    información incluida en esta Página Web se actualiza constantemente ni que incluye información reciente. Esta Página Web podrá dejar de funcionar,
    ser interrumpida o funcionar indebidamente de forma ocasional. No TIP o las Partes Exentas tienen responsabilidad por dicho cese de funcionamiento,
    interrupción o funcionamiento indebido. Los Clientes quedan advertidos de que la información contenida aquí podría contener errores técnicos, inexactitudes,
    errores de programación, virus desconocidos y omisiones. El Cliente asume todos los riesgos vinculados con el uso de esta Página Web, y acepta
    que TIP renuncia a toda garantía vinculada al uso de la aplicación Página Web por parte del Cliente. Ninguna información o asesoramiento oral o
    escrito dado por nosotros o nuestros representantes autorizados creará una garantía ni aumentará de ninguna forma el alcance de nuestras obligaciones
    tal cual se establecen en estos Términos y Condiciones.
  </p>

  <p> <strong>  Divisibilidad. </strong> </p>

  <p>
    Si cualquier cláusula de estos Términos y Condiciones resultara inválida, nula o inaplicable, las cláusulas restantes conservarán de todos modos su
    total validez y la cláusula inválida, nula o inaplicable será considerada como modificada de modo tal que sea válida y aplicable hasta el máximo alcance
    permitido por la ley.
  </p>

    <p> <strong>   Preguntas y comentarios. </strong> </p>

  <p>
  Los Clientes que tengan alguna pregunta o duda sobre los Términos y Condiciones de esta Página Web pueden ponerse en
  contacto al siguiente correo electrónico: <a href="mailto:contactolegal@tipmexico.com" > contactolegal@tipmexico.com </a>.
   </p>

  <p>

  Por último, el Cliente declara bajo protesta de decir verdad que entiende el contenido y alcance del presente documento, así como el valor y consecuencias legales,
  por lo que manifiesta su conformidad con el mismo.

  </p>




  `

  textoTerms = textoTerms;

}
